

import { SortableContainer, SortableElement, sortableHandle } from "react-sortable-hoc";
import { cloneElement, useRef, useState } from "react";
import useClickOutside from "../../../hooks/useClickOutside";

const DragHandle = sortableHandle(() => <span className="DragImage"></span>);

export const SortableList = SortableContainer(({ items, children }) => {
    return (
        <ul className="navigationSorting">
            {items.map((value, index) => {
                return (
                    <SortableItem
                        key={`item-${index}`}
                        index={index}
                        sortIndex={index}
                        title={value}
                        menuItems={items.length}
                    >
                        {children}
                    </SortableItem>
                );
            })}
        </ul>
    );
});

const SortableItem = SortableElement(({ title, sortIndex, menuItems, children }) => {
    const [isActive, setIsActive] = useState(false)

    const settingRef = useRef(null);
    useClickOutside(settingRef, () => setIsActive(false))

    const handleMenu = () => {
        setIsActive(!isActive);
    }

    const clonedChildren = children ? cloneElement(children, { title, index: sortIndex, setIsActive, menuItems }) : null;

    return (
        <li className="sortingList">
            <DragHandle />
            {title}
            <div className={`setting ${isActive ? "active" : ""}`} onClick={handleMenu} ref={settingRef}>
                <div className="thing" onClick={(e) => e.stopPropagation()}>
                    {clonedChildren}
                </div>
            </div>
        </li>
    )
});